import { render, staticRenderFns } from "./BaseSearchInputAdvanced.vue?vue&type=template&id=5823ff40&"
import script from "./BaseSearchInputAdvanced.vue?vue&type=script&lang=js&"
export * from "./BaseSearchInputAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchInputAdvanced.vue?vue&type=style&index=0&id=5823ff40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports